export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10052.00194772.jpg";